// add customer, vehcile
export const ADD_CUSTOMER_VEHICLE_REQUEST = 'ADD_CUSTOMER_VEHICLE_REQUEST';
export const ADD_CUSTOMER_VEHICLE_SUCCESS = 'ADD_CUSTOMER_VEHICLE_SUCCESS';
export const ADD_CUSTOMER_VEHICLE_FAIL = 'ADD_CUSTOMER_VEHICLE_FAIL';
export const CLEAR_ADD_CUSTOMER_VEHICLE_STATE =
  'CLEAR_ADD_CUSTOMER_VEHICLE_STATE';

// add customer
export const ADD_CUSTOMER_REQUEST = 'ADD_CUSTOMER_REQUEST';
export const ADD_CUSTOMER_SUCCESS = 'ADD_CUSTOMER_SUCCESS';
export const ADD_CUSTOMER_FAIL = 'ADD_CUSTOMER_FAIL';
export const CLEAR_ADD_CUSTOMER_STATE = 'CLEAR_ADD_CUSTOMER_STATE';

// Dashboard Owner

export const GET_CUSTOMER_LISTING_REQUEST = 'GET_CUSTOMER_LISTING_REQUEST';
export const GET_CUSTOMER_LISTING_SUCCESS = 'GET_CUSTOMER_LISTING_SUCCESS';
export const GET_CUSTOMER_LISTING_FAIL = 'GET_CUSTOMER_LISTING_FAIL';

// Single Customer

export const GET_CUSTOMER_REQUEST = 'GET_CUSTOMER_REQUEST';
export const GET_CUSTOMER_SUCCESS = 'GET_CUSTOMER_SUCCESS';
export const GET_CUSTOMER_FAIL = 'GET_CUSTOMER_FAIL';

// delete customer

export const DELETE_CUSTOMER_REQUEST = 'DELETE_CUSTOMER_REQUEST';
export const DELETE_CUSTOMER_SUCCESS = 'DELETE_CUSTOMER_SUCCESS';
export const DELETE_CUSTOMER_FAIL = 'DELETE_CUSTOMER_FAIL';

// updating customer list after deleting
export const UPDATE_CUSTOMER_LIST_ON_DELETE = 'UPDATE_CUSTOMER_LIST_ON_DELETE';

// clearing deleted customer state
export const CLEAR_DELETED_CUSTOMER_STATE = 'CLEAR_DELETED_CUSTOMER_STATE';

// Update Customer

export const UPDATE_CUSTOMER_REQUEST = 'UPDATE_CUSTOMER_REQUEST';
export const UPDATE_CUSTOMER_SUCCESS = 'UPDATE_CUSTOMER_SUCCESS';
export const UPDATE_CUSTOMER_FAIL = 'UPDATE_CUSTOMER_FAIL';
export const UPDATE_CUSTOMERS_LISTING = 'UPDATE_CUSTOMERS_LISTING';
export const CLEAR_UPDATE_CUSTOMER_STATE = 'CLEAR_UPDATE_CUSTOMER_STATE';
export const UPDATE_CUSTOMERS_LIST = 'UPDATE_CUSTOMERS_LIST';

// Get Service History
export const GET_SERVICE_HISTORY_REQUEST = 'GET_SERVICE_HISTORY_REQUEST';
export const GET_SERVICE_HISTORY_SUCCESS = 'GET_SERVICE_HISTORY_SUCCESS';
export const GET_SERVICE_HISTORY_FAIL = 'GET_SERVICE_HISTORY_FAIL';

// Export Customer

export const EXPORT_CUSTOMER_REQUEST = 'EXPORT_CUSTOMER_REQUEST';
export const EXPORT_CUSTOMER_SUCCESS = 'EXPORT_CUSTOMER_SUCCESS';
export const EXPORT_CUSTOMER_FAIL = 'EXPORT_CUSTOMER_FAIL';
export const CLEAR_EXPORT_CUSTOMER_STATE = 'CLEAR_EXPORT_CUSTOMER_STATE';

// Import Customer Vehicle

export const IMPORT_CUSTOMER_VEHICLE_REQUEST =
  'IMPORT_CUSTOMER_VEHICLE_REQUEST';
export const IMPORT_CUSTOMER_VEHICLE_SUCCESS =
  'IMPORT_CUSTOMER_VEHICLE_SUCCESS';
export const IMPORT_CUSTOMER_VEHICLE_FAIL = 'IMPORT_CUSTOMER_VEHICLE_FAIL';
export const CLEAR_IMPORT_CUSTOMER_VEHICLE_STATE =
  'CLEAR_IMPORT_CUSTOMER_VEHICLE_STATE';

// search customer

export const SEARCH_CUSTOMER_REQUEST = 'SEARCH_CUSTOMER_REQUEST';
export const SEARCH_CUSTOMER_SUCCESS = 'SEARCH_CUSTOMER_SUCCESS';
export const SEARCH_CUSTOMER_FAIL = 'SEARCH_CUSTOMER_FAIL';
export const CLEAR_SEARCH_CUSTOMER_STATE = 'CLEAR_SEARCH_CUSTOMER_STATE';
